// Dashboard Navigation Configuration
export const DASHBOARD_TABS = [
  { 
    id: 'appointment-management', 
    label: 'Appointments', 
    icon: 'Calendar',
  },
  { 
    id: 'booking-requests', 
    label: 'Booking Requests', 
    icon: 'Inbox',
  },
  { 
    id: 'patient-registration', 
    label: 'Patients Registration', 
    icon: 'Users',
  },
  { 
    id: 'check-in', 
    label: 'Check-In', 
    icon: 'CheckCircle',
  },
  { 
    id: 'billing', 
    label: 'Billing', 
    icon: 'CreditCard',
  },
  { 
    id: 'patient-details', 
    label: 'Patient Details', 
    icon: 'Users',
  },
  { 
    id: 'insurance-claim', 
    label: 'Claim Form', 
    icon: 'Shield',
  },
  // { 
  //   id: 'communication', 
  //   label: 'Messages', 
  //   icon: 'MessageSquare',
  // },
  // { 
  //   id: 'patient-emr', 
  //   label: 'Patient EMR', 
  //   icon: 'File',
  // }
];

// Registration Steps
export const REGISTRATION_STEPS = [
  { 
    id: 1, 
    title: 'Patient Details', 
    icon: '👤'
  },
  { 
    id: 2, 
    title: 'Insurance Info', 
    icon: '🛡️'
  },
  { 
    id: 3, 
    title: 'Photo, Vitals & Complete', 
    icon: '📸'
  }
];

// Blood Groups
export const BLOOD_GROUPS = [
  { value: '', label: 'Select blood group' },
  { value: 'A+', label: 'A+' },
  { value: 'A-', label: 'A-' },
  { value: 'B+', label: 'B+' },
  { value: 'B-', label: 'B-' },
  { value: 'AB+', label: 'AB+' },
  { value: 'AB-', label: 'AB-' },
  { value: 'O+', label: 'O+' },
  { value: 'O-', label: 'O-' },
  { value: 'Unknown', label: 'Unknown' }
];

// Gender Options
export const GENDER_OPTIONS = [
  { value: '', label: 'Select gender' },
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' }
];

// Relationship Types
export const RELATIONSHIP_TYPES = [
  { value: '', label: 'Select relationship' },
  { value: 'Self', label: 'Self (Head of Family)' },
  { value: 'Spouse', label: 'Spouse' },
  { value: 'Son', label: 'Son' },
  { value: 'Daughter', label: 'Daughter' },
  { value: 'Father', label: 'Father' },
  { value: 'Mother', label: 'Mother' },
  { value: 'Brother', label: 'Brother' },
  { value: 'Sister', label: 'Sister' },
  { value: 'Other', label: 'Other' }
];

// Appointment Status Colors
export const APPOINTMENT_STATUS_COLORS = {
  'Completed': 'bg-green-100 text-green-800 border-green-200',
  'Cancelled': 'bg-red-100 text-red-800 border-red-200',
  'InProgress': 'bg-yellow-100 text-yellow-800 border-yellow-200',
  'InQueue': 'bg-purple-100 text-purple-800 border-purple-200',
  'Scheduled': 'bg-blue-100 text-blue-800 border-blue-200'
};

// Professional Color Scheme - White Dominant
export const COLORS = {
  primary: {
    50: '#f0f9ff',
    100: '#e0f2fe',
    500: '#0ea5e9',
    600: '#0284c7',
    700: '#0369a1'
  },
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827'
  },
  success: {
    50: '#f0fdf4',
    100: '#dcfce7',
    500: '#22c55e',
    600: '#16a34a'
  },
  warning: {
    50: '#fffbeb',
    100: '#fef3c7',
    500: '#f59e0b',
    600: '#d97706'
  },
  error: {
    50: '#fef2f2',
    100: '#fee2e2',
    500: '#ef4444',
    600: '#dc2626'
  }
};

// Button Styles - Professional and Clean
export const BUTTON_STYLES = {
  primary: 'bg-[#2D869C] hover:bg-[#2D869C]/90 text-white font-semibold px-4 py-2 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg',
  secondary: 'bg-white hover:bg-[#9DC9D4]/10 text-[#838383] font-semibold px-4 py-2 rounded-lg border-2 border-[#2D869C] transition-all duration-200 shadow-sm hover:shadow-md',
  success: 'bg-[#A4EC90] hover:bg-[#A4EC90]/90 text-[#838383] font-semibold px-4 py-2 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg',
  warning: 'bg-[#CCB478] hover:bg-[#CCB478]/90 text-white font-semibold px-4 py-2 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg',
  danger: 'bg-[#E99797] hover:bg-[#E99797]/90 text-white font-semibold px-4 py-2 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg',
  outline: 'bg-white hover:bg-[#9DC9D4]/10 text-[#838383] font-semibold px-4 py-2 rounded-lg border-2 border-[#2D869C] transition-all duration-200',
  ghost: 'text-[#838383] hover:text-[#2D869C] hover:bg-[#9DC9D4]/10 font-semibold px-4 py-2 rounded-lg transition-all duration-200'
};

// Card Styles - Clean and Minimal with Theme
export const CARD_STYLES = {
  default: 'bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200',
  elevated: 'bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-200',
  highlight: 'bg-[#9DC9D4]/10 rounded-xl shadow-sm',
  warning: 'bg-[#CCB478]/10 rounded-xl shadow-sm',
  error: 'bg-[#E99797]/10 rounded-xl shadow-sm',
  success: 'bg-[#A4EC90]/10 rounded-xl shadow-sm'
};

// Input Styles - Clean and Professional with Theme
export const INPUT_STYLES = {
  default: 'w-full border border-[#9DC9D4]/40 rounded-lg px-4 py-2.5 text-sm text-[#838383] font-medium focus:ring-2 focus:ring-[#2D869C]/30 focus:border-[#2D869C] transition-all duration-200 bg-white placeholder-[#9D9D9D]',
  error: 'w-full border border-[#E99797] rounded-lg px-4 py-2.5 text-sm text-[#838383] font-medium focus:ring-2 focus:ring-[#E99797] focus:border-transparent transition-all duration-200 bg-[#E99797]/5',
  disabled: 'w-full border border-[#9D9D9D]/30 rounded-lg px-4 py-2.5 text-sm bg-gray-50 text-[#9D9D9D] cursor-not-allowed'
};

// Services for Billing
export const BILLING_SERVICES = [
  { value: '', label: 'Select service' },
  { value: 'consultation', label: 'Consultation - $150' },
  { value: 'checkup', label: 'Routine Checkup - $100' },
  { value: 'procedure', label: 'Minor Procedure - $300' },
  { value: 'lab-work', label: 'Lab Work - $75' },
  { value: 'imaging', label: 'Imaging/X-Ray - $200' }
];

// Payment Methods
export const PAYMENT_METHODS = [
  { value: '', label: 'Select payment method' },
  { value: 'cash', label: 'Cash' },
  { value: 'credit', label: 'Credit Card' },
  { value: 'debit', label: 'Debit Card' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'check', label: 'Check' }
];

// Billing Types (Backend enum)
export const BILLING_TYPES = [
  { value: 'Patient', label: 'Patient (Self-Pay)' },
  { value: 'Insurance', label: 'Insurance' },
  { value: 'Corporate', label: 'Corporate' }
];

// Communication Recipients
export const COMMUNICATION_RECIPIENTS = [
  { value: '', label: 'Select recipient' },
  { value: 'patient', label: 'Patient' },
  { value: 'doctor', label: 'Doctor' },
  { value: 'nurse', label: 'Nurse' },
  { value: 'admin', label: 'Administration' }
];

// Photo Capture Settings
export const PHOTO_CAPTURE = {
  maxFileSize: 5 * 1024 * 1024, // 5MB
  allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
  videoConstraints: {
    width: { ideal: 640, min: 320 },
    height: { ideal: 480, min: 240 },
    facingMode: 'user'
  },
  captureFormat: 'image/jpeg',
  captureQuality: 0.8
};

// Vitals Constants
export const VITALS_RANGES = {
  bloodPressure: {
    systolic: { min: 70, max: 250, normal: { min: 90, max: 140 } },
    diastolic: { min: 40, max: 150, normal: { min: 60, max: 90 } }
  },
  heartRate: { min: 30, max: 200, normal: { min: 60, max: 100 } },
  temperature: { min: 95, max: 110, normal: { min: 97, max: 99.5 } },
  respiratoryRate: { min: 8, max: 40, normal: { min: 12, max: 20 } },
  oxygenSaturation: { min: 70, max: 100, normal: { min: 95, max: 100 } },
  height: { min: 50, max: 300 }, // cm
  weight: { min: 1, max: 500 } // kg
};

// Temperature Units
export const TEMPERATURE_UNITS = [
  { value: 'fahrenheit', label: '°F (Fahrenheit)' },
  { value: 'celsius', label: '°C (Celsius)' }
];

// Height Units
export const HEIGHT_UNITS = [
  { value: 'cm', label: 'cm' },
  { value: 'ft', label: 'ft/in' }
];

// Weight Units
export const WEIGHT_UNITS = [
  { value: 'kg', label: 'kg' },
  { value: 'lbs', label: 'lbs' }
];
